import { useQuery } from "@tanstack/react-query";
import { SubPurchaseOrderService } from "src/services/purchaseOrders";

const useSubPurchaseOrder = (id: string | undefined, subPurchaseOrderService: SubPurchaseOrderService) => {
  const {
    data: subPurchaseOrder,
    error: fetchError,
    isLoading,
    refetch
  } = useQuery({
    queryKey: ["subPurchaseOrder", id],
    queryFn: () => subPurchaseOrderService.getSubPurchaseOrderById(id!),
    enabled: !!id
  });

  return { subPurchaseOrder, fetchError, isLoading, refetch };
};

export { useSubPurchaseOrder };
